import React from 'react';

const style = {
  backgroundColor: 'transparent',
  border: 'none',
  color: '#4183c4',
  cursor: 'pointer',
  textDecoration: 'none',
  display: 'inline',
  margin: 0,
  padding: 0
};

const LinkButton = (props) => {
  return <button style={style} {...props}></button>
};

export default LinkButton;
